export default{
	baseUrl:'https://admin.xslwf.com/',
	imgUrl:'/storage',
	platextApplys:'https://admin.xslwf.com/api/platextApplys',
	picture:'https://admin.xslwf.com/api/upload/homeUp'
}